/** @module csi/heading/Aggregate */
define([
	"csi/action/Aggregate",
	"csi/def/ActionFactory",
	"csi/locale",
	"csi/util",
	"./AttributeActionMixin"
], function(Aggregate, ActionFactory, locale, util, AttributeActionMixin) {

	return ActionFactory.declare("AggregateInline", [Aggregate, AttributeActionMixin], {
		// String: default id and tag for action - id is necessary to override id from base class
		m_id: "AggregateInline",
		m_tag: "AggregateInline",

		// Boolean: indicates whether or not to allow initial drop-down before dialog
		bDialogOnly: false,

		// csi.def.Heading: heading on which action will act (simulate AttributeAction)
		heading: null,

		/** @property {boolean} flattenAggregateClassReferences - action should find aggregate class reference and work with them rather than aggregate class itself (if any) */
		flattenAggregateClassReferences: false,

		constructor: function(def) {
			this.bDialogOnly = (util.getProperty(def, 'DialogOnly') == '1');

			// for any AggregateInline actions with AggregateClass, need to add referenced nodes to FormData rather than aggregate class nodes
			if (this.aggregateClass) {
				this.flattenAggregateClassReferences = true;
			}
		},

		/**
		 * Inline editing is not supported when AggregateAdd/New are used as they are not supported by the 
		 * multi-select widget and data stores (and probably don't need to be)
		 * NOTE: do not call this.inherited, as inline editing is OK when there is a ViewRef
		 */
		canBeInlined: function() {
			return !this.bDialogOnly && !this.bAggregateAdd && !this.bAggregateNew;
		},

		checkNodeAccess: function(/*Node*/node) {
			// summary: if reverse aggregate then only check for access to this node - skip attribute check
			if (this.bReverse) {
				return this.inherited(arguments);
			}

			return this._checkAttributeAccess(node, this.aggregateId, this.heading.m_path);
		},

		resolve: function() {
			// summary: aggregateId comes from parent Heading
			this.aggregateId = this.aggregateId || this.heading.m_id;
			this.inherited(arguments);

			// set tooltip as name that will be used as dialog title, and use default localization for action

			if (this.m_id == this.m_tag + this.aggregateId) {
				this.m_tooltip = this.m_name;
				this.m_name = locale.resource("ActionAttribute");
			}
		},

		_getNameParams: function(/*LocaleResolver*/lr) {
			// summary: return array of parameters used to help name action;
			// unlike base Aggregate action, here we know the name of the reverse relationship so we can do proper localization
			if (this.m_rcTarget && this.bReverse) {
				return [lr.getTypeAttribute(this.m_rcTarget.getType(), this.heading.m_id)];
			}

			return this.inherited(arguments);
		}
	});
});